var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logos.length)?_c('div',{staticClass:"flex justify-center gap-3 lg:gap-16",attrs:{"data-footer-logos":""}},_vm._l((_vm.logos),function({ image, alt },index){return _c('Vue2Image',{key:`footer_logo-${index}`,staticClass:"h-4",attrs:{"src":image.filename,"alt":alt,"quality":60}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }